export const STATUS_STYLES = {
    available: {
        border: "border-[#a6a6a6]",
        header: "bg-[#d1d1d1] text-[#101010]",
        title: "bg-white",
        body: "bg-[#f5f5f5]",
        counter: "bg-[#d1d1d1] text-[#101010] border-[#a6a6a6]",
    },
    onHold: {
        border: "border-[#efa429]",
        header: "bg-[#ffb947] text-white",
        title: "bg-[#fffcef]",
        body: "bg-white",
        counter: "bg-[#ffb947] text-white border-[#efa429]",
    },
    delayed: {
        border: "border-[#e3714f]",
        header: "bg-[#ff8b40] text-white",
        title: "bg-[#fff2ed]",
        body: "bg-white",
        counter: "bg-[#ff8b40] text-white border-[#e3714f]",
    },
    schedule: {
        border: "border-[#523782]",
        header: "bg-[#6A4D9F] text-white",
        title: "bg-[#f2edfd]",
        body: "bg-white",
        counter: "bg-[#6A4D9F] text-white border-[#523782]",
    },
    assignment: {
        border: "border-[#6fa2bd]",
        header: "bg-[#71c2ee] text-white",
        title: "bg-[#e3f4fd]",
        body: "bg-white",
        counter: "bg-[#71c2ee] text-white border-[#6fa2bd]",
    },
    inProgress: {
        border: "border-[#1a5f33]",
        header: "bg-[#33804E] text-white",
        title: "bg-[#effff0]",
        body: "bg-white",
        counter: "bg-[#33804E] text-white border-[#1a5f33]",
    },
    dispatch: {
        border: "border-[#1a5f33]",
        header: "bg-[#33804E] text-white",
        title: "bg-white",
        body: "bg-[#f5fff9]",
        counter: "bg-[#33804E] text-white border-[#1a5f33]",
    },
    dispatchSupport: {
        border: "border-[#5ac780]",
        header: "bg-[#67cd8b] text-white",
        title: "bg-white",
        body: "bg-[#f5fff9]",
        counter: "bg-[#67cd8b] text-white border-[#5ac780]",
    },
    dispatchActivity: {
        border: "border-[#02486b]",
        header: "bg-[#287499] text-white",
        title: "bg-white",
        body: "bg-[#e0f0f6]",
        counter: "bg-[#287499] text-white border-[#02486b]",
    },
    panic: {
        border: "border-[#a82824]",
        header: "bg-[#ef5744] text-white",
        title: "bg-[#ffe9e8]",
        body: "bg-[#ffe9e8]",
        counter: "bg-[#ef5744] text-white border-[#a82824]",
    },
};

export const SOURCE_COUNTER_CLASS = "bg-[#f5f5f5] text-[#777] border-[#a6a6a6]";

export const ATTENDANCE_STATUS_FILTERS = [
    {key: "panic", label: "Pânico"},
    {key: "delayed", label: "Atraso"},
    {key: "onHold", label: "Aberto"},
    {key: "assignment", label: "Atribuído"},
    {key: "schedule", label: "Agendado"},
    {key: "inProgress", countKey: "progress", label: "Em andamento"},
];

export const ATTENDANCE_SOURCE_FILTERS = [
    {key: "webGenerated", label: "Central", shortLabel: "C"},
    {key: "sos", label: "SOS", shortLabel: "S"},
    {key: "sentryAlarm", label: "Alarme Sentry", shortLabel: "AS"},
    {key: "contactId", label: "Alarme patrimonial", shortLabel: "AP"},
    {key: "dispatchHelp", label: "Chat", shortLabel: "CH"},
    {key: "external", label: "Fontes externas", shortLabel: "FE"},
];

export const TASK_STATUS_FILTERS = [
    {key: "onHold", label: "Aberto"},
    {key: "assignment", label: "Atribuído"},
    {key: "inProgress", label: "Em andamento"},
];

export const TASK_SOURCE_FILTERS = [
    {key: "attendance", label: "Atendimento", shortLabel: "A"},
    {key: "sos", label: "SOS", shortLabel: "S"},
    {key: "janitorial", label: "Zeladoria", shortLabel: "Z"},
];

export const GARRISON_STATUS_FILTERS = [
    {key: "panic", label: "Pânico"},
    {key: "dispatch", label: "Despachado"},
    {key: "dispatchSupport", label: "Apoio"},
    {key: "dispatchActivity", label: "Atividade"},
    {key: "available", label: "Disponível"},
];

export const GARRISON_SOURCE_FILTERS = [
    {key: "SELF_GENERATED", label: "Auto despacho", shortLabel: "A"},
    {key: "WEB_GENERATED", label: "Central", shortLabel: "C"},
    {key: "LEADER_GENERATED", label: "Responsável", shortLabel: "R"},
];

export const GARRISON_COMPOSITION_FILTERS = [
    {key: "WITH_VEHICLE", label: "Com veículo", shortLabel: "V"},
    {key: "WITHOUT_VEHICLE", label: "A pé", shortLabel: "P"},
];

export const GARRISON_INTENDED_FUNCTION_OPTIONS = [
    {value: "Administração", label: "Administração"},
    {value: "Patrulhamento", label: "Patrulhamento"},
    {value: "Posto fixo", label: "Posto fixo"},
];

export const getStatusStyle = (status) => STATUS_STYLES[status] ?? STATUS_STYLES.available;
